module.exports = __webpack_public_path__ + "img/bulk-transfer.d660faa5.svg";